/**
* In this file use to contains the Landing Template Sidebar Template and Main Content Template screens
**/
import constantVariables from './../../dataset/constantVariables.json';
import { Outlet,Link,useNavigate,NavLink,useLocation } from 'react-router-dom';
import { useEffect } from 'react';
//import { Carousel } from 'react-bootstrap';
import ApiService from './../../services/ApiService';

//Landing or Home page
export default function LandingTemplate(){
	
	//Variable declaration
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;
	
	/** To check the token exist or not **/
/*    useEffect(()=>{
	
	  var token = localStorage.getItem('token');
	     if(token){
			 var role = localStorage.getItem('role');
			 var path= parseInt(role)===1?'/parent/dashboard':parseInt(role)===2?'/physician/dashboard':'/admin/dashboard';
			 navigate(path);
		 }
		 
		const section = document.getElementById("indexPage");
		if (section) {
		  section.scrollIntoView({ behavior: 'smooth' });
		}
   },[navigate]); */
   const response = ApiService.isLoggedIn();
   useEffect(() => {
    const checkToken = async () => {
      if (response && response.status === 200) {
        const role =localStorage.getItem('role');
        const path =
          parseInt(role) === 1
            ? '/parent/dashboard'
            : parseInt(role) === 2
            ? '/physician/dashboard'
            : '/admin/dashboard';
        navigate(path);
      } else {
        localStorage.clear();
        const section = document.getElementById('indexPage');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    checkToken();
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

   
    /** This function is used to scroll down to the section 
	 * @sectionId - pass the id or section name
	**/
	/*const scrollToSection = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) {
		  section.scrollIntoView({ behavior: 'smooth' });
		}
    };*/
  
	return (
	<>
	{/** Header Section **/}
	<div id="indexPage">
	<header className={!['about', 'request' , 'parents' , 'clinics'].some(path => currentPath.includes(path)) && !currentPath.includes('privacy-policy') ? 'ipHeader' : 'subpgHeader'}>
		<div className="container">
			<nav className="navbar navbar-expand-lg navbar-light">	
				{/** logo **/}
				<span className="navbar-brand">
					<Link to='/'><img src="/assets/img/nurture-logo.svg" alt="logo" /></Link>
				</span>
				<button className="navbar-toggler" type="button" >
				  <span className="navbar-toggler-icon"></span>
				</button>
				
				<div className="collapse navbar-collapse" id="navbarTogglerDemo02">
					<ul className="navbar-nav ms-auto mb-2 mb-lg-0">
						<li className="nav-item">
						<NavLink to='/' activeclassname="active"><span className="nav-link" >{constantVariables.landing.home}</span></NavLink>
						</li>
						<li className="nav-item">
							<NavLink to='/about' activeclassname="active" className="nav-link">{constantVariables.landing.aboutNurture}</NavLink>
						</li>
						{/*<li className="nav-item">
						  <span className="nav-link"  onClick={() => scrollToSection('services')}>{constantVariables.landing.services}</span>
						</li>*/}
						<li className="nav-item">
						  <NavLink to='/parents' activeclassname="active" className="nav-link">{constantVariables.landing.parents}</NavLink>
						</li>
						<li className="nav-item">
						  <NavLink to='/clinics' activeclassname="active" className="nav-link">{constantVariables.landing.clinics}</NavLink>
						</li>
						{/*<li className="nav-item">
						  <span className="nav-link">{constantVariables.landing.contactUs}</span>
						</li>*/}
						<li className="nav-item">
						  <NavLink to='/request' className="nav-link">{constantVariables.landing.requestDemo}</NavLink>
						</li>
					</ul>
					<div className="mx-1">
						<div className="btn-group">
						<button type="button" className="btn btn-tmBlue px-4 me-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
							{constantVariables.landing.login}
						</button>
						  <ul className="dropdown-menu" style={{marginTop:'11px'}}>
							<li><Link className="dropdown-item" to='/login/physician'>{constantVariables.landing.physician}</Link></li>
							<li><Link className="dropdown-item" to='/login/admin'>{constantVariables.landing.admin}</Link></li>
							<li><Link className="dropdown-item" to='/login/hospital/admin'>{constantVariables.landing.hospital}</Link></li>
						  </ul>
							{/*<Link to='register' className="btn btn-tmPink px-4">
								{constantVariables.landing.signUp}
							</Link>*/}
					</div>
				</div>
				</div>
			</nav>
		
		</div>
	</header>
	<Outlet />
	{/** App Download Section **/}
	<section id="appDownload" className={!['request'].some(path => currentPath.includes(path)) ? 'd-block' : 'd-none'}>
		<div className="container">
			<div className="appBox"> 			 
				<div className="row align-items-center"> 			 
					<div className="col-lg-7">						
						<div className="sectionTitle">
							<h5 className="blueDot">{constantVariables.landing.downloadApp}</h5>
							<h4>{constantVariables.landing.downloadApp1}  <br />{constantVariables.landing.downloadApp2}</h4>
						</div>
						<div className="sectionContent">
							<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam quis nostrud exercitation.</p>
							<a href="https://play.google.com/store/apps/details?id=com.nurturelife.health"><img src="/assets/img/app-google-play.png" alt="lo" /></a>
							<a href="https://apps.apple.com/in/app/nurture-health/id6468662105"><img src="/assets/img/app-store.png" alt="lo" /></a>
						</div>
					</div>			 
					<div className="col-lg-5 text-center">
						<img src="/assets/img/app-download.png" className="img-fluid" alt="lo" />
					</div>
				</div>
			</div>
		</div>
	</section>
	{/** Footer Section **/}
	<footer className="footerSec">
		<div className="container">
			<div className="row"> 
				<div className="col-lg-12 text-center"> 
					<span className="logo"><img src="/assets/img/nurture-logo.svg" alt="log" /></span>
					<ul>
						<li><Link to='/'>{constantVariables.landing.home}</Link></li>
						<li><Link to="about">{constantVariables.landing.aboutNurture}</Link></li>
						<li><Link to="parents">{constantVariables.landing.parents}</Link></li>
						<li><Link to="clinics">{constantVariables.landing.clinics}</Link></li>
						{/*<li><Link>{constantVariables.landing.services}</Link></li>*/}
						{/*<li><Link>{constantVariables.landing.contactUs}</Link></li>*/}
						<li><Link>{constantVariables.landing.faq}</Link></li>
						<li><Link to="privacy-policy">{constantVariables.landing.privacyPolicy}</Link></li>
						<li><Link>{constantVariables.landing.terms}</Link></li>
					</ul>
					<p>{constantVariables.landing.copywrites}</p>
				</div>
			</div>
		</div>
	</footer>
	</div>
	</>
	);
}